import { statsData } from '@/mocks/homeData';

export default function StatsSection() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {statsData.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary-500 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}